import React from "react";
import FavoritesScreen from "../Components/favourite_product/favouriteScreen";

const FavouriteScreenPage = () => {
  return (
    <>
      <FavoritesScreen />
    </>
  );
};

export default FavouriteScreenPage ;
